import { useRouteLoaderData } from 'react-router-dom';
import Login from '../Login';

const LoginRouterWrapper = () => {
	const {
		apiEnvironment,
		clientId,
		customGenericErrorMessage,
		customerServicePhoneNumber,
		eligibilityURL,
		enableSSO,
		ineligibleRegistration,
		loginHostingPath,
		overrideMainTitleTo,
		redirectUri,
	} = useRouteLoaderData('identity');
	return (
		<Login
			apiEnvironment={apiEnvironment}
			clientId={clientId}
			customGenericErrorMessage={customGenericErrorMessage}
			customerServicePhoneNumber={customerServicePhoneNumber}
			eligibilityURL={eligibilityURL}
			enableSSO={enableSSO}
			ineligibleRegistration={ineligibleRegistration}
			loginHostingPath={loginHostingPath}
			overrideMainTitleTo={overrideMainTitleTo}
			redirectUri={redirectUri}
		/>
	);
};

export default LoginRouterWrapper;
